/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Network_Quick_Action_TitleInputs */

const de_home_network_quick_action_title = /** @type {(inputs: Home_Network_Quick_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heimnetz`)
};

/** @type {(inputs: Home_Network_Quick_Action_TitleInputs) => LocalizedString} */
const en_home_network_quick_action_title = de_home_network_quick_action_title;

/**

* @param {Home_Network_Quick_Action_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const home_network_quick_action_title = /** @type {((inputs?: Home_Network_Quick_Action_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Network_Quick_Action_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_home_network_quick_action_title(inputs)
	return en_home_network_quick_action_title(inputs)
});